import api from "@/services/api";
import { CreateAssociatePayload } from "@/services/associates/CreateAssociate";

export interface UpdateAssociatePayload extends CreateAssociatePayload {
  associateId: string;
}

class UpdateAssociate {
  execute = async (payload: UpdateAssociatePayload) => {
    const response = await api().put("/associate", payload);
    return response.data;
  };
}

export { UpdateAssociate };




